import client from './client';

/** Fetches the Customer/Vehicle/Policies/Claims bundle for the logged-in customer. */
export async function fetchData() {
  const response = await client.get('/api/care-portal/data');
  return response.data;
}
